import axios from 'axios';
import store from '@/store/store';
import { actions as _act } from '@/models/store.actions';

export const blankService = {
  Get,
  AdminGet,
  AdminDataGet,
  Add,
  Edit,
  Del
};

let model = {
  get baseUrl() {
    return store.getters[_act.SETT_GET_APIURLGET];
  },
  controller: 'Blank'
};

function extract(r) {
  return r.data;
}

async function Get() {
  return axios.get(`${model.baseUrl}${model.controller}/Get`).then(extract);
}

async function AdminGet() {
  return axios.get(`${model.baseUrl}${model.controller}/AdminGet`).then(extract);
}

async function AdminDataGet(blanksId) {
  return axios.get(`${model.baseUrl}${model.controller}/AdminDataGet?blanksId=${blanksId}`).then(extract);
}

async function Add(documentCode, permissions) {
  return axios
    .put(`${model.baseUrl}${model.controller}/Add`, {
      documentCode: documentCode,
      permissions: permissions
    })
    .then(extract);
}

async function Edit(blanksId, permissions) {
  return axios
    .patch(`${model.baseUrl}${model.controller}/Edit`, {
      blanksId: blanksId,
      permissions: permissions
    })
    .then(extract);
}

async function Del(blanksId) {
  return axios
    .delete(`${model.baseUrl}${model.controller}/Del`, {
      data: {
        blanksId: blanksId
      }
    })
    .then(extract);
}
